import { render, staticRenderFns } from "./MultiFormUpload.vue?vue&type=template&id=3c5fa1f9&"
import script from "./MultiFormUpload.vue?vue&type=script&lang=js&"
export * from "./MultiFormUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports